import { reversPathTasks } from '../../../../utils';
import { splitTextHTML } from '../../../../utils/lookahead-common';
import { getIsOdd, getParentProperties } from './utils';

const RenderRoute = ({ task, column }) => {
  if (!task || !task.isTask || task.is_milestone) return '';

  /** get activity reference */
  const [activityRoute, parentName] = getParentProperties(task);

  /** get is odd */
  const isOdd = getIsOdd(task, column);

  return `<div class=${isOdd ? 'odd-col' : 'non-odd-col'}>
            <span>
                ${splitTextHTML(
                  reversPathTasks(`${activityRoute} > ${parentName}`),
                  column,
                  task?.id
                )}
            </span>
        </div>`;
};

export default RenderRoute;
